(() => {
  function refreshDisclaimer() {
    if (document.body.classList.contains('tw-b2b')) return;
    const freeShippingThreshold = Number(
      window.DELIVERY_FREE_SHIPPING_THRESHOLD
    );
    if (!(freeShippingThreshold > 0)) return;

    const shippingParent = document.querySelector('.cart_items_wr');
    if (!shippingParent) return;

    const itemsSubtotalCents = Number(
      shippingParent.querySelector('.shipping__total-price')?.dataset
        .itemsSubtotal
    );
    if (Number.isNaN(itemsSubtotalCents)) return;
    const cartTotal = itemsSubtotalCents / 100;
    const progressWidth =
      cartTotal >= freeShippingThreshold
        ? 100
        : (cartTotal / freeShippingThreshold) * 100;

    const progressBar = shippingParent.querySelector('.progress_bar');
    if (!progressBar) return;

    progressBar.style.width = `${progressWidth}%`;

    const moreToGoImage = shippingParent.querySelector('.more-to-go');
    const freeShippingImage = shippingParent.querySelector(
      '.shipping__icon .free'
    );
    const deliveryDisclaimer = shippingParent.querySelector(
      '.delivery-disclaimer'
    );
    const freeDelivery = shippingParent.querySelector('.delivery-free');
    const remainderSpan = shippingParent.querySelector('.remainder');
    const shippingValueEl = document
      .getElementById('main-cart-footer')
      ?.querySelector('[data-cart-shipping-value]');

    if (cartTotal < freeShippingThreshold) {
      remainderSpan.textContent = ` ${window.formatMoneyAmount(freeShippingThreshold - cartTotal)} `;
      freeDelivery.classList.add('hidden');
      freeShippingImage.classList.add('hidden');
      deliveryDisclaimer.classList.remove('hidden');
      moreToGoImage.classList.remove('hidden');
      if (shippingValueEl)
        shippingValueEl.textContent = shippingValueEl.dataset.shippingDefault;
    } else {
      moreToGoImage.classList.add('hidden');
      deliveryDisclaimer.classList.add('hidden');
      freeDelivery.classList.remove('hidden');
      freeShippingImage.classList.remove('hidden');
      if (shippingValueEl)
        shippingValueEl.textContent = shippingValueEl.dataset.shippingFree;
    }
  }

  function updateSectionsFromResponse(sections) {
    const parser = new DOMParser();

    const footerHtml = sections?.['main-cart-footer'];
    if (footerHtml) {
      const doc = parser.parseFromString(footerHtml, 'text/html');

      const newJsContents = doc.querySelector('.js-contents');
      const existingJsContents = document
        .getElementById('main-cart-footer')
        ?.querySelector('.js-contents');
      if (newJsContents && existingJsContents) {
        existingJsContents.innerHTML = newJsContents.innerHTML;
      }

      const newDynamicCheckout = doc.querySelector('.js-cart-dynamic-checkout');
      const existingDynamicCheckout = document
        .getElementById('main-cart-footer')
        ?.querySelector('.js-cart-dynamic-checkout');
      if (newDynamicCheckout && existingDynamicCheckout) {
        existingDynamicCheckout.innerHTML = newDynamicCheckout.innerHTML;
      }
    }

    const itemsHtml = sections?.['main-cart-items'];
    if (itemsHtml) {
      const doc = parser.parseFromString(itemsHtml, 'text/html');
      const newJsContents = doc.querySelector('.js-contents');
      const existingJsContents = document
        .getElementById('main-cart-items')
        ?.querySelector('.js-contents');
      if (newJsContents && existingJsContents) {
        existingJsContents.innerHTML = newJsContents.innerHTML;
      }

      const newProgress = doc.querySelector('.cart-progress-zone');
      const existingProgress = document.getElementById('cart-progress-zone');
      if (newProgress && existingProgress) {
        existingProgress.innerHTML = newProgress.innerHTML;
      }
    }

    refreshDisclaimer();
  }

  async function cartPageRefreshSections() {
    const itemsSection =
      document.getElementById('main-cart-items')?.dataset.id ||
      'main-cart-items';
    const footerSection =
      document.getElementById('main-cart-footer')?.dataset.id ||
      'main-cart-footer';

    try {
      const params = encodeURIComponent(`${itemsSection},${footerSection}`);
      const resp = await fetch(
        `${window.location.pathname}?sections=${params}`,
        { cache: 'no-store' }
      );
      if (!resp.ok) return;
      const sections = await resp.json();
      updateSectionsFromResponse({
        'main-cart-items': sections[itemsSection],
        'main-cart-footer': sections[footerSection]
      });
    } catch (err) {}
  }

  window.cartPageRefreshSections = cartPageRefreshSections;

  document.addEventListener('cart:discount:applied', e => {
    updateSectionsFromResponse(e.detail?.sections);
  });

  document.addEventListener('cart:discount:removed', e => {
    updateSectionsFromResponse(e.detail?.sections);
  });

  function observeFooterUpdates() {
    const footer = document.getElementById('main-cart-footer');
    const target = footer?.querySelector('.js-contents');
    if (!target) {
      document.addEventListener('DOMContentLoaded', () => {
        const f = document.getElementById('main-cart-footer');
        const t = f?.querySelector('.js-contents');
        if (t) {
          new MutationObserver(() => refreshDisclaimer()).observe(t, {
            childList: true
          });
        }
      });
      return;
    }
    new MutationObserver(() => refreshDisclaimer()).observe(target, {
      childList: true
    });
  }

  observeFooterUpdates();

  document.addEventListener(
    'click',
    e => {
      const btn = e.target.closest(
        '.cart__checkout-button-new[data-test="cartCheckoutBtn"]'
      );
      if (!btn) return;

      const stored = Number(localStorage.getItem('cart:total_discount') || 0);
      if (!stored) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const payload = {
        event: 'custom_event',
        event_name: 'coupon_discount_value',
        parameter: JSON.stringify({
          from: 'cart_page',
          coupon_discount_value: `${stored / 100}`
        })
      };

      window.dataLayer = window.dataLayer || [];
      if (
        window.google_tag_manager &&
        window.google_tag_manager['GTM-5GDFLPX']
      ) {
        payload.eventCallback = function (gtmId) {
          if (gtmId === 'GTM-5GDFLPX') {
            document.getElementById('checkout')?.click();
          }
        };
        payload.eventTimeout = 2000;
        window.dataLayer.push(payload);
      } else {
        window.dataLayer.push(payload);
        document.getElementById('checkout')?.click();
      }
    },
    true
  );
})();

(() => {
  const isElementVisible = element => {
    const rect = element.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight;
  };

  const itemOverFooter = () => {
    const footer = document.querySelector('.footer');
    const stickyCheckout = document.querySelector('.mobile__sticky-checkout');
    if (!footer || !stickyCheckout) return;
    const footerTop = footer.getBoundingClientRect().top + window.scrollY;
    const buttonTop =
      stickyCheckout.getBoundingClientRect().top + window.scrollY;
    const buttonHeight = stickyCheckout.offsetHeight;
    if (buttonTop + buttonHeight < footerTop) {
      stickyCheckout.classList.remove('white');
    } else {
      stickyCheckout.classList.add('white');
    }
  };

  const setStickyMode = () => {
    const stickyCheckout = document.querySelector('.mobile__sticky-checkout');
    const cartCheckoutButton = document.querySelector(
      '.cart__ctas .cart__checkout-button-new'
    );
    if (!stickyCheckout || !cartCheckoutButton) return;
    const anyButtonVisible = isElementVisible(cartCheckoutButton);
    if (!anyButtonVisible && !stickyCheckout.classList.contains('sticky')) {
      stickyCheckout.classList.add('sticky');
    } else if (
      anyButtonVisible &&
      stickyCheckout.classList.contains('sticky')
    ) {
      stickyCheckout.classList.remove('sticky');
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mobile__sticky-checkout').forEach(el => {
      el.addEventListener('click', () => {
        const checkoutButton = document.querySelector(
          '.cart__ctas .cart__checkout-button-new'
        );
        if (checkoutButton) checkoutButton.click();
      });
    });

    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'change',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body });
          }, 300)
        );
      }
    }
    customElements.define('cart-note', CartNote);

    document.querySelectorAll('.modal_info_btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const modal = document.querySelector('.modal');
        if (modal) modal.classList.toggle('open');
        document.body.classList.add('active');
      });
    });
    document.querySelectorAll('.close').forEach(btn => {
      btn.addEventListener('click', () => {
        const modal = document.querySelector('.modal');
        if (modal) modal.classList.remove('open');
        document.body.classList.remove('active');
      });
    });
    document.addEventListener('mouseup', e => {
      const container = document.querySelector(
        '.modal_info .modal_info-content'
      );
      if (container && !container.contains(e.target)) {
        document.body.classList.remove('active');
        const modal = document.querySelector('.modal');
        if (modal) modal.classList.remove('open');
      }
    });
    document
      .querySelectorAll('.icartShopifyCartContent')
      .forEach(el => el.classList.add('container'));
  });

  window.addEventListener('load', () => {
    const mediaQuery = window.matchMedia('(max-width: 991px)');
    if (mediaQuery.matches) {
      setTimeout(setStickyMode, 100);
      document.addEventListener('scroll', () => {
        setStickyMode();
        itemOverFooter();
      });
    }
  });
})();

(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const ua = window.navigator.userAgent;
    const isIE = ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0;
    if (!isIE) return;
    const cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    document.querySelector('#checkout').addEventListener('click', () => {
      document.querySelector('#cart').submit();
    });
  });

  if (window.innerWidth <= 768) {
    $('.icartShopifyCartContent.container .cart__footer').prependTo(
      '.cart__footer-upsell'
    );
  }
})();
